/**
 * Text component to show the bag id for the user.
 *
 * @module views/components/BagId
 * @memberof -Common
 */

import React, { useRef } from 'react';

import PropTypes from 'prop-types';

import Text from '@ulta/core/components/Text/Text';
import { useIntersectionObserver } from '@ulta/core/hooks/useIntersectionObserver/useIntersectionObserver';
import { handleIntersection } from '@ulta/core/utils/intersectionProcessor/intersectionProcessor';

import constants from '@ulta/utils/constants/constants';


/**
 * Represents a BagId component
 *
 * @method
 * @param { BagIdProps} props - React properties passed from composition
 * @returns BagId
 */
export const BagId = function( props ){

  const { text, textStyle, root = defaultProps.root, rootMargin = defaultProps.rootMargin, threshold = defaultProps.threshold } = props;

  const dataCaptureRef = useRef();
  useIntersectionObserver(
    dataCaptureRef,
    {
      root: root,
      rootMargin: rootMargin,
      threshold: threshold
    },
    handleIntersection( props )
  );

  if( !text ){
    return null;
  }

  return (
    <div className='BagId'>
      { textStyle &&
        <Text
          htmlTag='p'
          textStyle={ textStyle }
          textAlign='left'
          color='neutral-600'
        >
          { text }
        </Text>
      }
    </div>
  );
};

/**
 * Property type definitions
 * @typedef BagIdProps
 * @type {object}
 * @property {string} text - refactor or delete
 */
export const propTypes =  {
  text: PropTypes.string
};

export const defaultProps = {
  ...constants.INTERSECTION_OBSERVER_OPTIONS
};

BagId.propTypes = propTypes;
BagId.defaultProps = defaultProps;

export default BagId;
